import {scrollImageSection} from "../components/scroll-image-section";

export function initPrimoLanding() {
    if (!$('#primo_landing').length) return;
    scrollImageSection();
}
